// extracted by mini-css-extract-plugin
module.exports = {"w3wk0ms":"w3wk0ms","fullRotation-w3wk0ms":"fullRotation-w3wk0ms"};